import React from "react";
import { Box, Text, Link } from "@chakra-ui/react";

export const LinkifyText = ({ text }) => {
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

  const getShortUrl = (url) => {
    const normalizedUrl = url.startsWith("http") ? url : "https://" + url;

    try {
      const u = new URL(normalizedUrl);
      return `🔗 ${u.hostname}`;
    } catch {
      return url;
    }
  };

  const renderText = () => {
    const elements = [];
    let lastIndex = 0;

    for (const match of text.matchAll(urlRegex)) {
      const url = match[0];
      const index = match.index ?? 0;

      // Add plain text before the match
      if (lastIndex < index) {
        elements.push(
          <Text as="span" key={`text-${lastIndex}`}>
            {text.slice(lastIndex, index)}
          </Text>
        );
      }

      // Add the link
      const href = url.startsWith("http") ? url : `https://${url}`;
      elements.push(
        <Link key={`link-${index}`} href={href} isExternal color="blue.500" textDecoration="underline" mx={0.5}>
          {getShortUrl(url)}
        </Link>
      );

      lastIndex = index + url.length;
    }

    // Add remaining text after last match
    if (lastIndex < text.length) {
      elements.push(
        <Text as="span" key={`text-end`}>
          {text.slice(lastIndex)}
        </Text>
      );
    }

    return elements;
  };

  return <Box>{renderText()}</Box>;
};
